import { render, staticRenderFns } from "./travelerDetail.vue?vue&type=template&id=068922c6&scoped=true&"
import script from "./travelerDetail.vue?vue&type=script&lang=js&"
export * from "./travelerDetail.vue?vue&type=script&lang=js&"
import style0 from "./travelerDetail.vue?vue&type=style&index=0&id=068922c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068922c6",
  null
  
)

export default component.exports